import { create } from "zustand";
import { User } from "../features/auth/types";

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,

  // Call this when login succeeds or when the app loads and fetches the user
  setUser: (user) => set({ user, isAuthenticated: !!user }),

  // Call this on logout
  clearAuth: () => set({ user: null, isAuthenticated: false }),
}));
